import _ from 'lodash'
import { format, parse } from 'date-fns';
import { Message } from 'element-ui'

const getters = {
  //common.js
  exchange: state => state.common.exchange,
  brandList: state => state.common.brandList,
  classifyList: state => state.common.classifyList,
  getCategoryName: state => {
    return (categoryId) => {
      let name = ''
      state.common.classifyList.forEach(first => {
        if (first.classifyId == categoryId) {
          name = first.classifyEnglishName
        }
        first.secondClassify.forEach(second => {
          if (second.classifyId == categoryId) {
            name = second.classifyEnglishName
          }
        })
      })
      return name
    }
  },
  popularityBrands: state => state.common.popularityBrands.filter(e => !_.isEmpty(e.brandImg)),
  payTypeList: state => state.common.payTypeList,
  //user.js
  token: state => state.user.token,
  isLogin: state => {
    if (state.user.token) { return true }
    return false
  },
  balance: state => state.user.balance,
  integral: state => state.user.integral,
  nickname: state => {
    return state.user.nickname ? state.user.nickname : state.user.username
  },
  /**
   * addressType:0：中国、1：澳洲、2：其它
   */
  getAddressList: state => {
    return ({ addressType }) => {
      return addressType ? state.user.addressList.filter(ads => addressType == undefined || ads.addType == addressType) || [] : state.user.addressList
    }
  },
  // /**
  //  * 迁移至 common.js
  //  * @returns
  //  * @deprecated
  //  */
  // countrydbToCountryvo: () => {
  //     return (countrydb) => {
  //         switch (countrydb) {
  //             case '澳洲': return 'Australia'
  //             case '中国': return 'China'
  //             case '台湾(中国)': return 'Taiwan'
  //             case '香港(中国)': return 'Hongkong'
  //             default: return countrydb
  //         }
  //     }
  // },
  // /**
  //  * 迁移至 common.js
  //  * @returns
  //  * @deprecated
  //  */
  // countryvoToCountrydb: () => {
  //     return (countryvo) => {
  //         switch (countryvo) {
  //             case 'Australia': return '澳洲'
  //             case 'China': return '中国'
  //             case 'Taiwan': return '台湾(中国)'
  //             case 'Hongkong': return '香港(中国)'
  //             default: return countryvo
  //         }
  //     }
  // },
  // /**
  //  * 地址详情转化接口转显示层
  //  * @param {*} state
  //  * @param {*} getters
  //  * @returns
  //  * @deprecated

  //  */
  // addressdbToAddressvo: (state, getters) => {
  //     return (addressdb) => {
  //         let {
  //             addressId,
  //             contacts,
  //             contactPhone,
  //             postCode,
  //             area,
  //             addressDetail,
  //             countryName,
  //         } = addressdb;
  //         console.log(getters)
  //         let country = getters.countrydbToCountryvo(countryName)

  //         area = area.split("-");
  //         return {
  //             addressId: addressId,
  //             addressee: contacts,
  //             phone: contactPhone,
  //             country,
  //             city: postCode,
  //             cityName: area,
  //             addressDetails: addressDetail
  //         };
  //     }
  // },
  // /**
  //  * 地址详情转化显示层转接口
  //  * @param {*} state
  //  * @param {*} getters
  //  * @returns
  //  * @deprecated
  //  */
  // addressvoToAddressdb: (state, getters) => {
  //     return (addressvo) => {
  //         let {
  //             addressId,
  //             addressee,
  //             phone,
  //             city,
  //             cityName,
  //             addressDetails,
  //             country
  //         } = addressvo;
  //         let zipCode = city.join(",");
  //         let [provinceName, cityName2, areaName] = cityName;
  //         let countryName = getters.countryvoToCountrydb(country);
  //         let addType;
  //         switch (country) {
  //             case "China":
  //                 addType = "0";
  //                 break;
  //             case "Australia":
  //                 addType = "1";
  //                 break;
  //             default:
  //                 addType = "2";
  //         }
  //         return {
  //             addressId,
  //             addType,
  //             contacts: addressee,
  //             contactPhone: phone,
  //             countryName,
  //             provinceName,
  //             cityName: cityName2,
  //             areaName,
  //             addressDetail: addressDetails,
  //             zipCode
  //         };
  //     }
  // },
  //cart.js

  /**
   * 计算当前购物车内选中商品价值
   * 当goodsActionTypeId不为空时只计算普通商品和该类别下活动所属商品
   * @param {goodsActionTypeId} state
   * @returns
   */
  cartTotal: state => {
    return (goodsActionTypeId) => {
      let total = 0.00
      let goodsList = []
      state.cart.shoppingCart.forEach(goods => {
        if (goods.checked) {
          total = _.add(total, _.multiply(goods.memberPrice, goods.goodsAmount))
          goodsList.push({
            goodsEnglishName: goods.goodsEnglishName,
            goodsAmount: goods.goodsAmount,
            memberPrice: goods.memberPrice,
            isSelf: goods.isSelf
          })
        }
      })
      const promotionsShoppingCart = _.isEmpty(goodsActionTypeId) ? state.cart.promotionsShoppingCart : state.cart.promotionsShoppingCart.filter(e => e.goodsActionTypeId === goodsActionTypeId)
      let promotionList = []
      promotionsShoppingCart.forEach(promotion => {
        let thisGoodsList = [];
        promotion.shoppingCart.forEach(goods => {
          if (goods.checked) {
            total = _.add(total, _.multiply(goods.memberPrice, goods.goodsAmount))
            thisGoodsList.push({
              goodsEnglishName: goods.goodsEnglishName,
              goodsAmount: goods.goodsAmount,
              memberPrice: goods.memberPrice,
              isSelf: goods.isSelf
            })
          }
        })
        if (thisGoodsList.length > 0) {
          let thisPromotion = {
            goodsActionTypeId: promotion.goodsActionTypeId,
            goodsActionTypeName: promotion.goodsActionTypeName,
            goodsActionTypeNameEn: promotion.goodsActionTypeNameEn,
            goodsList: thisGoodsList
          }
          promotionList.push(thisPromotion)
        }

      })
      return { total, goodsList, promotionList }
    }
  },


  /**
   * 抽取所有选中商品
   * @param {*} state
   * @returns 多个活动都存在选中商品时返回空对象
   *          正常返回含 goodsList promotion promotionGoodsList 对象
   */
  getCheckedGoods: (state) => {
    //普通商品直接添加
    let goodsList = []
    state.cart.shoppingCart.forEach(goods => {
      if (goods.checked) {
        goodsList.push(goods)
      }
    });
    //活动商品 两个活动不可同时结算
    let promotionsHasCheckedGoodsList = []
    let promotionGoodsList = []
    let promotion = {}
    state.cart.promotionsShoppingCart.forEach((promotion, i, arr) => {

      let hasChecked = false;
      promotion.shoppingCart.forEach(e => { hasChecked = e.checked || hasChecked })
      if (hasChecked) {
        promotionsHasCheckedGoodsList.push(promotion)
      }
    })
    if (promotionsHasCheckedGoodsList.length > 1) {
      Message({ type: "warning", message: 'Multiple promotions cannot be ordered at the same order' })
      return false

    } else if (promotionsHasCheckedGoodsList.length === 1) {

      promotion = promotionsHasCheckedGoodsList[0]
      promotion.shoppingCart.forEach(goods => {
        if (goods.checked) {
          promotionGoodsList.push(goods)
        }
      });

    }

    return { goodsList, promotion, promotionGoodsList }
  },
  getGoodsItemCount: (state) => {
    let count = state.cart.shoppingCart.length
    state.cart.promotionsShoppingCart.forEach(
      promotion => {
        count += promotion.shoppingCart.length
      }
    )
    return count
  },
  /**
   *
   * @param {*} state
   * @returns
   */
  getShoppingCarts: (state) => {
    let normalShoppingCart = {
      goodsActionTypeName: "普通",
      goodsActionTypeNameEn: "normal",
      shoppingCart: state.cart.shoppingCart,
      valid: true
    };
    let promotionsShoppingCart = state.cart.promotionsShoppingCart;
    promotionsShoppingCart.forEach(promotion => {
      // console.log(new Date().getTime())
      // console.log(parse(promotion.endTime,'dd/MM/yyyy HH:mm',new Date()).getTime())
      promotion.valid =
        new Date().getTime() <
        parse(promotion.endTime, "dd/MM/yyyy HH:mm", new Date()).getTime();
    });
    return (state.cart.shoppingCart || []).length > 0 ? _.concat(normalShoppingCart, promotionsShoppingCart) : promotionsShoppingCart;
  },
  //goods.js
  specialAreaList: (state) => {
    let specialAreaList =
      state.goods.specialAreaList.map(sa => {
        let {
          id,
          mallGoodsClassifyName,
          mallGoodsClassifyNameEn,
          checked
        } = sa
        return {
          id,
          mallGoodsClassifyName,
          mallGoodsClassifyNameEn,
          checked
        }
      })
    return specialAreaList
  },
  //order.js
  isDelivery: (state) => state.order.deliveryType === 'delivery',
  isPickup: (state) => state.order.deliveryType === 'pickup',
  deliveryInfoIntact: (state, getters) => {
    if (getters.isPickup) {
      let { pickupShopId, pickupTime } = state.order.pickup
      let can = (!_.isEmpty(pickupShopId)) && (!_.isEmpty(pickupTime + ""))
      return can
    }
    if (getters.isDelivery) {
      let addressObj = state.order.address

      let { country, addressee, phone, city, addressDetails }
        = addressObj
      let boo = (
        (!_.isEmpty(addressee))
        && (!_.isEmpty(phone))
        && (!_.isEmpty(addressDetails))
        && (!_.isEmpty(country))
      )
      let countries = ["Australia", "China", "Malaysia", "TaiWan"]
      if (
        countries.indexOf(country) != -1
        && _.isEmpty(city)) {
        boo = false
      }
      return boo
    }
    return false
  },
  pickupTime: (state) => state.order.pickup.pickupTime ? format(new Date(state.order.pickup.pickupTime), 'dd/MM/yyyy HH:mm') : '',
  cityName: (state) => (state.order.address.cityName || []).join('-'),
  active: (state) => state.order.active || 0,
  getShippType: (state) => {
    // console.log(state)
    return (deliveryType) => {
      if (!deliveryType) {
        deliveryType = state.order.deliveryType
      }
      if (deliveryType === 'delivery') {
        //澳洲境内 中国 全球
        // console.log(state.order.address)
        if ("Australia" === state.order.address.country) {
          return "2"
        } else {
          return "1"
        }
      } else if (deliveryType === 'pickup') {
        return "3"
      } else if (deliveryType === 'fature') {
        //feture
      } else {
        return ""
      }
    }

  },
  getPromotion: (state) => state.order.promotion,
  getPayType: (state) => state.order.payType.payType,
  isSpecialPay: (state) => ["transfer", "cashOnDelivery", "0"].includes(state.order.payType.payType),
  getOrderNo: (state) => state.order.orderNo
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js